/** Answer feedback rising from the bottom: robo-cat happy/sad, one-line explanation. */
import { useEffect, useRef } from 'react';
import { RoboCat } from '../../ui/RoboCat.tsx';
import { Icon } from '../../ui/Icon.tsx';

export function FeedbackSheet({
  correct,
  xp,
  answer,
  explanation,
  onContinue,
}: {
  correct: boolean;
  xp: number;
  answer: string;
  explanation: string | null;
  onContinue: () => void;
}) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => buttonRef.current?.focus(), []);

  return (
    <div className={`feedback feedback--${correct ? 'correct' : 'wrong'}`} role="status" aria-live="polite">
      <div className="feedback__head">
        <span className="feedback__badge" aria-hidden="true">
          <Icon name={correct ? 'check' : 'refresh'} size={18} />
        </span>
        <strong className="feedback__title">{correct ? 'Верно!' : 'Почти. Запомним вместе'}</strong>
        {xp > 0 && <span className="feedback__xp">+{xp} XP</span>}
      </div>
      <div className="feedback__body">
        <RoboCat size={62} state={correct ? 'happy' : 'sad'} />
        <div className="feedback__bubble">
          <span className="tutor-label">Учитель</span>
          {!correct && (
            <p>
              Правильно: <span className="han feedback__answer">{answer}</span>
            </p>
          )}
          {explanation && <p>{explanation}</p>}
          {correct && !explanation && <p>Так держать.</p>}
        </div>
      </div>
      <button ref={buttonRef} type="button" className="btn btn--primary btn--block" onClick={onContinue}>
        Продолжить
      </button>
    </div>
  );
}
